// @flow
import * as React from "react"
import { Text } from "componentsStyled/Typography/Texts"
import { AffiliateLink, AffiliateItemWrap, ImageWrap, Banner } from "./styled"

type Props = {|
  children: React.Node,
  imgUrl: string,
  to: string,
  hasPassport: boolean,
|}

const AffiliateItem = ({ children, imgUrl, to, hasPassport }: Props) => (
  <AffiliateLink to={to} draggable="false">
    <AffiliateItemWrap>
      <ImageWrap>
        <img src={imgUrl} alt="Store" draggable="false" />
        {hasPassport && <Banner><Text white strong>PASS</Text></Banner>}
      </ImageWrap>
      <Text black medium center lh={2}>
        {children}
      </Text>
    </AffiliateItemWrap>
  </AffiliateLink>
)

export default AffiliateItem
  


// WEBPACK FOOTER //
// ./src/components/AffiliateList/AffiliateItem/index.js